(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fieldfire-canonical-product"]) return;
  try {
    
  document.querySelectorAll('.ff-purchase').forEach(function (product) {
    var form = product.querySelector('.ff-purchase__form');
    var bar = document.querySelector('.ff-purchase__sticky');
    if (!form || !bar || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (entries) {
      bar.hidden = entries[0].isIntersecting || entries[0].boundingClientRect.bottom > 0;
    }).observe(form);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fieldfire-contact-form"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll("[data-fieldfire-contact-form]").forEach((form) => {
    if (form.dataset.ready === "true") return;
    form.dataset.ready = "true";
    const submit = form.querySelector("button[type='submit']");
    const label = form.querySelector("[data-submit-label]");
    const status = form.querySelector("[data-contact-status]");
    const endpoint = form.dataset.endpoint;
    const defaultLabel = label ? label.textContent : "";
    if (!document.querySelector("script[data-fieldfire-turnstile-api]")) {
      const script = document.createElement("script");
      script.src = "https://challenges.cloudflare.com/turnstile/v0/api.js";
      script.async = true;
      script.defer = true;
      script.dataset.fieldfireTurnstileApi = "true";
      document.head.appendChild(script);
    }
    form.addEventListener("submit", async (event) => {
      event.preventDefault();
      if (!endpoint || !submit || !status) return;
      submit.disabled = true;
      if (label) label.textContent = form.dataset.submittingText || defaultLabel;
      status.dataset.state = "";
      status.textContent = "";
      try {
        const payload = Object.fromEntries(new FormData(form).entries());
        const response = await fetch(endpoint, { method: "POST", headers: { "Accept": "application/json", "Content-Type": "application/json" }, body: JSON.stringify(payload) });
        const data = await response.json();
        if (response.ok && data.ok === true) {
          form.reset();
          status.dataset.state = "success";
          status.textContent = form.dataset.successText || "";
          if (window.turnstile) window.turnstile.reset();
          return;
        }
        status.dataset.state = "error";
        status.textContent = data.error === "rate_limited" ? form.dataset.rateLimitedText || "" : form.dataset.errorText || "";
      } catch (error) {
        status.dataset.state = "error";
        status.textContent = form.dataset.errorText || "";
      } finally {
        submit.disabled = false;
        if (label) label.textContent = defaultLabel;
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
